import { securityHelper } from "../../../../helpers/securityHelper";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { checkForUpdatesOneLevel, deepClone, checkForFormUpdates } from "../../../../helpers/objectHelper";
import { elementOrgin } from "../../../../cms/helpers/elementHelper";
import { pageConstants } from "../../../../constants/cms/page/page.constants";
import { arrayHelper } from "../../../../helpers/arrayHelper";
import { Array } from "core-js";

const defaultPage = {
  pageId: 0,
  eventId: 0,
  isSavable: false,
  name: "Default page",
  pages: 1,
  pageElements: [],
  selectedElement: null,
  currentPage: 1,
  selectedContainer: null,
  eventName: "Jirango",
  paths: [],
};

export function page(state = defaultPage, action) {
  switch (action.type) {
    case pageConstants.PAGE_ATTACH:
      var pageElements = Array.from(state.pageElements);
      var pageElement = Object.assign({}, state.element);
      const sortNo = arrayHelper.getMaxValue(pageElements, "sortOrder");

      pageElement.sortOrder = sortNo;
      pageElement.page = state.currentPage;
      pageElement.data = JSON.parse(pageElement.data);
      pageElement.contentId = securityHelper.createGuid();

      pageElements.push(pageElement);

      return {
        ...state,
        pageElements,
        isSavable: true,
      };

    case pageConstants.RESTORE_PAGE:
      return {
        ...state,
        pageElements: [],
        selectedContainer: null,
        selectedElement: null,
        isSavable: true,
      };

    case pageConstants.DELETE_PAGE_ELEMENT:
      var pageElements = arrayHelper.sortByParam(state.pageElements, "sortOrder");
      var indexOfRemovedEl = pageElements.indexOf(action.element);

      if (indexOfRemovedEl > -1) {
        pageElements.splice(indexOfRemovedEl, 1);
        for (let index = indexOfRemovedEl; index < pageElements.length; index++) {
          pageElements[index].sortOrder = pageElements[index].sortOrder - 1;
        }
      }

      if (action.element.type === elementConstants.CONTAINER) {
        const containerChildren = [
          ...pageElements.filter((el, index) => {
            return el.parentId === action.element.id;
          }),
        ];
        const containerChildrenChildren = [
          ...pageElements.filter((el, index) => {
            if (containerChildren.find((cel) => cel.id === el.parentId)) return el;
          }),
        ];
        containerChildren.map((el, index) => {
          let elToRemove = pageElements.find((sc, i) => {
            if (sc.contentId === el.contentId) {
              return Object.assign({}, el);
            }
          });
          pageElements.splice(pageElements.indexOf(elToRemove), 1);
        });
        containerChildrenChildren.map((el, index) => {
          let elToRemove = pageElements.find((sc, i) => {
            if (sc.contentId === el.contentId) {
              return Object.assign({}, el);
            }
          });
          pageElements.splice(pageElements.indexOf(elToRemove), 1);
        });
      }

      return {
        ...state,
        pageElements,
        isSavable: true,
        selectedElement: null,
      };

    case pageConstants.DESELECT_PAGE_ELEMENT:
      return {
        ...state,
        selectedElement: null,
        selectedContainer: null,
      };

    case pageConstants.PAGE_SELECT:
      /*      if (
                     action.element.type === elementConstants.CONTAINER &&
                     action.element.parentId === null
                 ) {
                     const containerId = action.element.id;
                     const containerChildId = state.pageElements
                         .filter(el => {
                             return el.parentId === containerId;
                         })
                         .map(el => {
                             return el.id;
                         });
                     const hasChildren = state.pageElements.filter(el => {
                         return containerChildId.includes(el.parentId);
                     });
                     if (hasChildren.length > 0) {
                         return {
                             ...state,
                             selectedContainer: action.element,
     
                         };
                     }
                 }
     
                 if (
                     state.pageElements.find(el => {
                         return el.contentId === action.element.contentId;
                     }) &&
                     action.element.type === elementConstants.CONTAINER &&
                     action.element.parentId === null
                 ) {
                     return {
                         ...state,
                         selectedContainer: action.element,
                         selectedElement: null
                     };
                 }
                 const parentChild = state.pageElements.find(el => {
                     return el.id === action.element.parentId;
                 });
     
                 if (parentChild && state.selectedContainer) {
                     if (parentChild.parentId === state.selectedContainer.id) {
                         return {
                             ...state,
                             selectedElement: action.element
                         };
                     }
                 } else {
                     return {
                         ...state,
                         selectedElement: action.element,
                         selectedContainer:
                             state.selectedContainer &&
                                 action.element.parentId !== state.selectedContainer.Id
                                 ? null
                                 : state.selectedContainer
                     };
                 } */
      var pageElements = Array.from(state.pageElements);

      if (action.element.type === elementConstants.CONTAINER && action.element.parentId === null) {
        const containerId = action.element.id;

        const containerChildId = pageElements
          .filter((el) => {
            return el.parentId === containerId;
          })
          .map((el) => {
            return el.id;
          });
        const hasChildren = pageElements.filter((el) => {
          return containerChildId.includes(el.parentId);
        });

        if (hasChildren.length > 0) {
          return {
            ...state,
            selectedContainer: action.element,
          };
        }
      }

      if (action.element.parentId === null && arrayHelper.findByParam(pageElements, "contentId", action.element.contentId) && action.element.type === elementConstants.CONTAINER) {
        const selectedContainer = Object.assign({}, action.element);
        return {
          ...state,
          selectedContainer,
        };
      }

      const parentChild = arrayHelper.findByParam(pageElements, "id", action.element.parentId);

      if (parentChild && state.selectedContainer) {
        if (parentChild.parentId === state.selectedContainer.id) {
          const selectedElement = Object.assign({}, action.element);
          return {
            ...state,
            selectedElement,
          };
        }
      } else {
        return {
          ...state,
          selectedElement: action.element,
          selectedContainer: state.selectedContainer && action.element.parentId !== state.selectedContainer.Id ? null : state.selectedContainer,
        };
      }

    case pageConstants.UPDATE_PAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case pageConstants.UPDATE_PAGE_ELEMENT:
      let newPageElements = Array.from(state.pageElements);
      let newSelectedElement = state.selectedElement;
      let newSelectedContainer = state.selectedContainer;
      if (newSelectedElement !== null) {
        if (Array.isArray(action.element)) {
          action.element.map((ae) => {
            newPageElements = newPageElements.map((el) => {
              if (el.contentId == ae.contentId) {
                let newEl = deepClone(ae);
                if (state && state.selectedElement && state.selectedElement.contentId === el.contentId) {
                  newSelectedElement = newEl;
                }
                return newEl;
              } else return el;
            });
          });
        } else {
          newPageElements = newPageElements.map((el) => {
            if (el.contentId == action.element.contentId) {
              let newEl = deepClone(action.element);
              if (state && state.selectedElement && state.selectedElement.contentId === el.contentId) {
                newSelectedElement = newEl;
              }
              return newEl;
            } else return el;
          });
        }
      }
      if (newSelectedContainer !== null) {
        if (Array.isArray(action.element)) {
          action.element.map((ae) => {
            newPageElements = newPageElements.map((el) => {
              if (el.contentId == ae.contentId) {
                let newEl = deepClone(ae);
                if (state && state.selectedContainer && state.selectedContainer.contentId === el.contentId) {
                  newSelectedContainer = newEl;
                }
                return newEl;
              } else return el;
            });
          });
        } else {
          newPageElements = newPageElements.map((el) => {
            if (el.contentId == action.element.contentId) {
              let newEl = deepClone(action.element);
              if (state && state.selectedContainer && state.selectedContainer.contentId === el.contentId) {
                newSelectedContainer = newEl;
              }
              return newEl;
            } else return el;
          });
        }
      }

      if (action.element != null && !newSelectedElement) {
        newPageElements = newPageElements.map((el) => {
          if (el.contentId == action.element.contentId) {
            let newEl = deepClone(action.element);
            if (state && state.selectedElement && state.selectedElement.contentId === el.contentId) {
              newSelectedElement = newEl;
            }
            return newEl;
          } else return el;
        });
      }

      return {
        ...state,
        pageElements: newPageElements,
        selectedElement: newSelectedElement,
        selectedContainer: newSelectedContainer,
        isSavable: true,
      };
    case pageConstants.UPDATE_PAGE_SUCCESS:
      var pageElements = Array.from(arrayHelper.sortByParam(action.page.content, "sortOrder"));
      if (pageElements !== null) {
        pageElements.map((e) => {
          e.data = JSON.parse(e.data);
          e.data = checkForFormUpdates(e.data, elementOrgin(e.type));
          e.contentId = securityHelper.createGuid();
          return Object.assign({}, e);
        });
      }
      return {
        ...state,
        ...action.page,
        pageElement,
        loading: false,
        updated: action.page.updated,
        isSavable: false,
      };
    case pageConstants.UPDATE_PAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case pageConstants.SOFT_UPDATE_PAGE:
      var page = Object.assign({}, action.page);
      return {
        ...state,
        ...page,
        isSavable: true,
      };
    case pageConstants.GET_PAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case pageConstants.GET_PAGE_SUCCESS:
      var pageElements = Array.from(arrayHelper.sortByParam(action.page.content, "sortOrder"));
      if (pageElement !== null) {
        pageElements.map((e) => {
          e.data = JSON.parse(e.data);
          e.data = checkForUpdatesOneLevel(e.data, elementOrgin(e.type));
          e.contentId = securityHelper.createGuid();
          e.isValid = true;
          e.forceValidationMessage = false;
          return Object.assign({}, e);
        });
      }
      return {
        ...state,
        ...action.page,
        pageId: action.page.pageId,
        languageCode: action.page.languageCode,
        eventId: action.page.eventId,
        name: action.page.name,
        title: action.page.title,
        eventName: action.page.eventName,
        inherit: action.page.inherit,
        currentPage: 1,
        selectedContainer: null,
        pageElements,
        selectedElement: null,
        currentPage: 1,
        updated: action.page.lastModified,
        templateId: action.page.templateId,
        loading: false,
      };
    case pageConstants.GET_PAGE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case pageConstants.GET_ALL_PAGE_PATHS:
      state.paths = action.pages;
      return state;
    default:
      return state;
  }
}

/*
function handleSelected(element, source){

    if(element.parentId !== null){

    }
    else if(element.type === elementConstants.CONTAINER){
        const containerId = element.id;
        const containerChildId = source.filter(el => { return el.parentId === containerId }).map(el => { return el.id });
        const hasChildren = source.filter(el => { return containerChildId.includes(el.parentId) })

        if (hasChildren.length > 0) {
            return {
                ...state,
                selectedContainer: null
            };
        }
    }
    else{

    }


    if (action.element.type === elementConstants.CONTAINER && action.element.parentId === null) {
        const containerId = action.element.id;

        const containerChildId = pageElements.filter(el => { return el.parentId === containerId }).map(el => { return el.id });
        const hasChildren = pageElements.filter(el => { return containerChildId.includes(el.parentId) })

        if (hasChildren.length > 0) {
            return {
                ...state,
                selectedContainer: null
            };
        }
    }

    if (
        action.element.parentId === null &&
        arrayHelper.findByParam(pageElements, 'contentId', action.element.contentId) &&
        action.element.type === elementConstants.CONTAINER
    ) {
        const selectedContainer = Object.assign({}, action.element);
        return {
            ...state,
            selectedContainer

        };
    }

    const parentChild = arrayHelper.findByParam(pageElements, 'id', action.element.parentId);

    if (parentChild && state.selectedContainer) {
        if (parentChild.parentId === state.selectedContainer.id) {
            const selectedElement = Object.assign({}, action.element);
            return {
                ...state,
                selectedElement
            };
        }
    } else {
        return {
            ...state,
            selectedElement: action.element,
            selectedContainer:
                state.selectedContainer &&
                    action.element.parentId !== state.selectedContainer.Id
                    ? null
                    : state.selectedContainer
        };
    }
} */
